"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.insuranceProviderList = exports.agencyInformation = exports.mortgageLookups = exports.lookupsJson = exports.enhancedRoofWindstormValues = exports.affinityGroups = exports.getInsuranceScoreGroup = exports.getFinancialResponsibilityTier = exports.getMVRStates = exports.getValue = exports.getOptions = exports.inThisState = exports.setState = exports.createLookupsByName = exports.createLookupsById = void 0;
const affinityGroups_1 = __importDefault(require("./affinityGroups"));
exports.affinityGroups = affinityGroups_1.default;
const constants = __importStar(require("./constants"));
const lookups_json_1 = __importDefault(require("./lookups.json"));
exports.lookupsJson = lookups_json_1.default;
const mortgageLookups_json_1 = __importDefault(require("./mortgageLookups.json"));
exports.mortgageLookups = mortgageLookups_json_1.default;
const enhancedRoofWindstormValues_json_1 = __importDefault(require("./enhancedRoofWindstormValues.json"));
exports.enhancedRoofWindstormValues = enhancedRoofWindstormValues_json_1.default;
lookups_json_1.default.affinityPartners = Object.keys(affinityGroups_1.default).map((ag) => {
    const { name, hideFromOffers } = affinityGroups_1.default[ag];
    return {
        id: ag,
        value: String(name || ag),
        hideFromOffers
    };
});
const createLookupsById = (mortgageLookups) => mortgageLookups.reduce((acc, curr) => {
    if (curr.id) {
        acc[curr.id] = curr;
        return acc;
    }
    return acc;
}, {});
exports.createLookupsById = createLookupsById;
const createLookupsByName = (mortgageLookups) => mortgageLookups.reduce((acc, curr) => {
    if (curr.possibleNames) {
        for (const name of curr.possibleNames) {
            acc[name] = curr;
        }
    }
    return acc;
}, {});
exports.createLookupsByName = createLookupsByName;
let currentState;
/**
 * @deprecated The values returned by setState, inThisState, getOptions, and getValue are untyped.
 * Consider using the `lookupsJson` object exported by this module or the constants exported
 * by the module such as `autoCoveragesToSave` and `homeCoveragesToSave` directly instead.
 */
function setState(state) {
    currentState = state;
}
exports.setState = setState;
/**
 * @deprecated The values returned by setState, inThisState, getOptions, and getValue are untyped.
 * Consider using the `lookupsJson` object exported by this module or the constants exported
 * by the module such as `autoCoveragesToSave` and `homeCoveragesToSave` directly instead.
 */
function inThisState(name) {
    return constants[name] && constants[name][currentState];
}
exports.inThisState = inThisState;
/**
 * @deprecated The values returned by setState, inThisState, getOptions, and getValue are untyped.
 * Consider using the `lookupsJson` object exported by this module or the constants exported
 * by the module such as `autoCoveragesToSave` and `homeCoveragesToSave` directly instead.
 */
function getOptions(name, stateIn, lookupsObj, policyType) {
    const state = stateIn || currentState;
    // uses lookupsObj if passed, in other case uses lookups
    const lookupsObject = lookupsObj || lookups_json_1.default;
    if (lookupsObject[`${name}State`] && lookupsObject[`${name}State`][state]) {
        if (policyType) {
            return lookupsObject[`${name}State`][state][policyType];
        }
        return lookupsObject[`${name}State`][state];
    }
    return lookupsObject[name];
}
exports.getOptions = getOptions;
/**
 * @deprecated The values returned by setState, inThisState, getOptions, and getValue are untyped.
 * Consider using the `lookupsJson` object exported by this module or the constants exported
 * by the module such as `autoCoveragesToSave` and `homeCoveragesToSave` directly instead.
 */
function getValue(name, idOrObj, stateIn, lookupsObj) {
    if (idOrObj === null || idOrObj === undefined) {
        return '';
    }
    const state = stateIn || currentState;
    // uses lookupsObj if passed, in other case uses lookups
    const lookupsObject = lookupsObj || lookups_json_1.default;
    // If we have a primitive value as second parameter we just
    // return the lookup with that value, if it's an object we use
    // idOrObj[name] to retrieve the value, this is a helper for those
    // cases where the key is equals to the object property
    let lookup;
    const lookupArray = lookupsObject[`${name}State`] && lookupsObject[`${name}State`][state]
        ? lookupsObject[`${name}State`][state]
        : lookupsObject[name];
    if (typeof idOrObj !== 'object') {
        lookup = lookupArray.find((v) => v.id === idOrObj);
    }
    else {
        lookup = lookupArray.find((v) => v.id === idOrObj[name]);
    }
    return (lookup && lookup.value) || '';
}
exports.getValue = getValue;
/* This function is a placeholder for being able to dynamically select which states
 * will have be used for the MVR service, in anticipation that we will want to make
 * different selections based upon different circumstances
 */
function getMVRStates() {
    return constants.mvrStates;
}
exports.getMVRStates = getMVRStates;
function getFinancialResponsibilityTier(primaryInsuranceScore, secondaryInsuranceScore) {
    let insuranceScore = primaryInsuranceScore;
    if (secondaryInsuranceScore) {
        // there is a coapplicant, so we construct a combined score
        insuranceScore += secondaryInsuranceScore;
        // divide by two
        insuranceScore /= 2;
    }
    if (insuranceScore <= 283) {
        return 'A-1';
    }
    if (insuranceScore <= 305) {
        return 'B-1';
    }
    if (insuranceScore <= 324) {
        return 'C-1';
    }
    if (insuranceScore <= 342) {
        return 'D-1';
    }
    if (insuranceScore <= 360) {
        return 'E-1';
    }
    if (insuranceScore <= 381) {
        return 'F-1';
    }
    if (insuranceScore <= 402) {
        return 'G-1';
    }
    if (insuranceScore <= 427) {
        return 'H-1';
    }
    if (insuranceScore <= 447) {
        return 'I-1';
    }
    if (insuranceScore <= 467) {
        return 'J-1';
    }
    if (insuranceScore <= 485) {
        return 'K-1';
    }
    if (insuranceScore <= 508) {
        return 'L-1';
    }
    if (insuranceScore <= 537) {
        return 'M-1';
    }
    if (insuranceScore <= 606) {
        return 'N-1';
    }
    if (insuranceScore <= 730) {
        return 'O-1';
    }
    if (insuranceScore <= 802) {
        return 'P-1';
    }
    if (insuranceScore <= 905) {
        return 'Q-1';
    }
    if (insuranceScore <= 999) {
        return 'R-1';
    }
    throw new Error('Invalid insurance score');
}
exports.getFinancialResponsibilityTier = getFinancialResponsibilityTier;
function getInsuranceScoreGroup(insuranceScore) {
    if (insuranceScore <= 231) {
        return 1;
    }
    if (insuranceScore <= 250) {
        return 2;
    }
    if (insuranceScore <= 266) {
        return 3;
    }
    if (insuranceScore <= 279) {
        return 4;
    }
    if (insuranceScore <= 291) {
        return 5;
    }
    if (insuranceScore <= 297) {
        return 6;
    }
    if (insuranceScore <= 305) {
        return 7;
    }
    if (insuranceScore <= 313) {
        return 8;
    }
    if (insuranceScore <= 320) {
        return 9;
    }
    if (insuranceScore <= 326) {
        return 10;
    }
    if (insuranceScore <= 332) {
        return 11;
    }
    if (insuranceScore <= 338) {
        return 12;
    }
    if (insuranceScore <= 343) {
        return 13;
    }
    if (insuranceScore <= 349) {
        return 14;
    }
    if (insuranceScore <= 354) {
        return 15;
    }
    if (insuranceScore <= 360) {
        return 16;
    }
    if (insuranceScore <= 366) {
        return 17;
    }
    if (insuranceScore <= 372) {
        return 18;
    }
    if (insuranceScore <= 378) {
        return 19;
    }
    if (insuranceScore <= 384) {
        return 20;
    }
    if (insuranceScore <= 390) {
        return 21;
    }
    if (insuranceScore <= 396) {
        return 22;
    }
    if (insuranceScore <= 402) {
        return 23;
    }
    if (insuranceScore <= 408) {
        return 24;
    }
    if (insuranceScore <= 414) {
        return 25;
    }
    if (insuranceScore <= 421) {
        return 26;
    }
    if (insuranceScore <= 427) {
        return 27;
    }
    if (insuranceScore <= 434) {
        return 28;
    }
    if (insuranceScore <= 441) {
        return 29;
    }
    if (insuranceScore <= 448) {
        return 30;
    }
    if (insuranceScore <= 452) {
        return 31;
    }
    if (insuranceScore <= 458) {
        return 32;
    }
    if (insuranceScore <= 464) {
        return 33;
    }
    if (insuranceScore <= 471) {
        return 34;
    }
    if (insuranceScore <= 479) {
        return 35;
    }
    if (insuranceScore <= 487) {
        return 36;
    }
    if (insuranceScore <= 495) {
        return 37;
    }
    if (insuranceScore <= 503) {
        return 38;
    }
    if (insuranceScore <= 512) {
        return 39;
    }
    if (insuranceScore <= 522) {
        return 40;
    }
    if (insuranceScore <= 531) {
        return 41;
    }
    if (insuranceScore <= 541) {
        return 42;
    }
    if (insuranceScore <= 551) {
        return 43;
    }
    if (insuranceScore <= 562) {
        return 44;
    }
    if (insuranceScore <= 575) {
        return 45;
    }
    if (insuranceScore <= 590) {
        return 46;
    }
    if (insuranceScore <= 606) {
        return 47;
    }
    if (insuranceScore <= 626) {
        return 48;
    }
    if (insuranceScore <= 657) {
        return 49;
    }
    if (insuranceScore <= 999) {
        return 50;
    }
    throw new Error('Invalid insurance score');
}
exports.getInsuranceScoreGroup = getInsuranceScoreGroup;
var agencyInformation_1 = require("./agencyInformation");
Object.defineProperty(exports, "agencyInformation", { enumerable: true, get: function () { return __importDefault(agencyInformation_1).default; } });
var insuranceProviderList_1 = require("./insuranceProviderList");
Object.defineProperty(exports, "insuranceProviderList", { enumerable: true, get: function () { return __importDefault(insuranceProviderList_1).default; } });
__exportStar(require("./constants"), exports);
